import {
  createSelectorHooks,
  ZustandHookSelectors
} from 'auto-zustand-selectors-hook'
import create from 'zustand'

interface Order {
  form: any
  productId: string
  product: any
  isDrawerOpen: boolean
  setIsDrawerOpen: (open: boolean) => void
  setProductId: (productId: string) => void
  setProduct: (product: any) => void
  setForm: (form: any) => void
}

const useStoreBase = create<Order>()((set) => ({
  form: {},
  productId: '',
  product: {},
  isDrawerOpen: false,
  setIsDrawerOpen: (isDrawerOpen: boolean) => set(() => ({ isDrawerOpen })),
  setProductId: (productId: string) => set(() => ({ productId })),
  setProduct: (product: any) => set(() => ({ product })),
  setForm: (data: any) =>
    set((state: any) => ({ form: { ...state.form, ...data } }))
}))

export const useItemConfigurationReplicateDrawerStore = createSelectorHooks(
  useStoreBase
) as typeof useStoreBase & ZustandHookSelectors<Order>
